<template>
  <div id="answers">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>All User Answers</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="transactions"
            :search="search"
            :items-per-page="20"
          >
            <template v-slot:item.created_at="{ item }">
              <h4>{{ item.created_at | moment('timezone', timezone, " h:mm:ss a") }}</h4>
              {{ item.created_at | moment('timezone', timezone, " Do MMMM YYYY") }}
            </template>
            <template v-slot:item.speed="{ item }"><span v-if="item.speed !== null">{{item.speed}}s</span></template> 
            <template
              v-slot:item.name="{ item }"
            >{{ item.user.firstname + ' ' + item.user.lastname }}</template>
            <!-- <template v-slot:item.amount="{ item }">${{ (item.amount/100).toFixed(2) }}</template>
            <template v-slot:item.balance="{ item }">${{ (item.balance/100).toFixed(2) }}</template>  -->
            
            <template v-slot:item.question.option_a="{ item }"><span :class="{ 'correct':  item.correct_answer == 'A', 'incorrect': !item.answered_correctly && item.correct_answer == 'A', 'incorrect': !item.answered_correctly && item.given_answer == 'a'}">{{item.question.option_a}}</span></template> 
            <template v-slot:item.question.option_b="{ item }"><span :class="{ 'correct':  item.correct_answer == 'B', 'incorrect': !item.answered_correctly && item.correct_answer == 'B', 'incorrect': !item.answered_correctly && item.given_answer == 'b'}">{{item.question.option_b}}</span></template> 
            <template v-slot:item.question.option_c="{ item }"><span :class="{ 'correct':  item.correct_answer == 'C', 'incorrect': !item.answered_correctly && item.correct_answer == 'C', 'incorrect': !item.answered_correctly && item.given_answer == 'c'}">{{item.question.option_c}}</span></template> 
            <template v-slot:item.question.option_d="{ item }"><span :class="{ 'correct':  item.correct_answer == 'D', 'incorrect': !item.answered_correctly && item.correct_answer == 'D', 'incorrect': !item.answered_correctly && item.given_answer == 'd'}">{{item.question.option_d}}</span></template> 
          </v-data-table>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "GameTransactions",
  data() {
    return {
      search: "",
      transactions: [],
      headers: [
        { text: "Date", value: "created_at", align: "start" },
        { text: "Speed", value: "speed"},
        { text: "Name", value: "name" },
        { text: "Email", value: "user.email" },
        { text: "Region", value: "user.region" },
        { text: "Question Id", value: "question_id" },
        { text: "Question", value: "question.question" },
        { text: "A", value: "question.option_a" },
        { text: "B", value: "question.option_b" },
        { text: "C", value: "question.option_c" },
        { text: "D", value: "question.option_d" },
        { text: "Difficulty", value: "question.difficulty" },
      ]
    };
  },
  mounted() {
    this.getGameTransactions();
    this.getTimezone();
  },
  computed: {},
  methods: {
    getGameTransactions() {
      if (this.transactions == "undefined" || this.transactions.length < 1) {
        this.$store.dispatch("retrieveAdminGameTransactions").then(() => {
          this.transactions = this.$store.getters.adminGameTransactions;
        });
      }
    },
    getTimezone() {
      this.timezone = this.$moment.tz.guess();
    }
  }
};
</script>

<style scoped>
.container.fill-height > .row {
  max-width: initial;
}

.correct {
  color: green;
  display: block;
}

.incorrect {
  color: red;
  display: block;
}
</style>